import { modelDataEntryLogs } from "./firebase";

const MAX_ENTRIES = 50;

// All new data-entry log entries are written here (one document per model,
// keyed by the model's uId) instead of inline on the carMake model object.
// Historical entries for makes that haven't been migrated (everything
// except Ford, as of the Ford migration) still live inline on the model's
// own `dataEntryLogs` field, so reads must combine both sources.
export async function writeDataEntryLog({ modelUId, makeId, makeName, modelName, entry }) {
  if (!modelUId) return;
  const ref = modelDataEntryLogs.doc(modelUId);
  const snap = await ref.get();
  const existing = snap.exists ? (snap.data().dataEntryLogs || []) : [];

  const updated = [entry, ...existing].slice(0, MAX_ENTRIES);

  await ref.set({
    makeId,
    makeName,
    modelUId,
    modelName,
    dataEntryLogs: updated,
    updatedAt: new Date().toISOString(),
  });
}

// Combines a model's inline dataEntryLogs (legacy/non-migrated makes) with
// whatever has been written to the modelDataEntryLogs collection for that
// model uId, newest first.
export async function fetchCombinedDataEntryLogs(model) {
  const inline = Array.isArray(model?.dataEntryLogs) ? model.dataEntryLogs : [];

  if (!model?.uId) return inline;

  try {
    const snap = await modelDataEntryLogs.doc(model.uId).get();
    const fromCollection = snap.exists ? (snap.data().dataEntryLogs || []) : [];
    return [...fromCollection, ...inline].sort((a, b) => (b.timeStamp || 0) - (a.timeStamp || 0));
  } catch (e) {
    console.error("Failed to fetch modelDataEntryLogs:", e);
    return inline;
  }
}
